import { $api } from "@/lib/api-client";

interface UseRemoveFromCartOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useRemoveFromCart = (options?: UseRemoveFromCartOptions) => {
  return $api.useMutation("post", "/cart/decrease/{id}", {
    onSuccess: () => {
      options?.onSuccess?.();
    },
  });
};
